<template>
    <b-card>
        <div class="d-flex flex column align-self-center">
            <IconEvaluation :width="32" :height="28" fill="#009ADA" class="mr-1" />
            <span class="page-title">
                {{ $t('values.moduleName') }}
            </span>
        </div>

        <div class="d-flex flex-row justify-content-end mb-0">
            <b-button
                id="btn-values-spontaneous-evaluation"
                v-if="showSpontaneousEvaluationButton"
                size="sm"
                class="mr-2"
                variant="primary"
                @click="getSpontaneousEvaluation()"
            >
                {{ $t('values.spontaneousEvaluation') }}
            </b-button>
            <filters :user="currentUser" @search="filters = $event" @ready="filters = $event" />
        </div>
        <nav-bar class="mb-3" :model="selectedStatus" :amounts="evaluationAmounts" @change="onClickNavBarItem" />
        <div ref="evaluations" style="min-height: 50px; position: relative">
            <evaluation
                :key="evaluation.id"
                :evaluation="evaluation"
                v-for="evaluation in evaluations"
                @evaluation-sented="onSentEvaluation"
                @evaluation-accepted="onAcceptEvaluation"
                @evaluation-declined="onDeclineEvaluation"
                @evaluation-edition-enabled="getEvaluationsInfo"
            />
            <div
                v-if="evaluations.length === 0"
                class="d-flex justify-content-center align-items-center flex-column text-center"
            >
                <b-alert style="min-width: 700px" show>{{ $t('values.emptyEvaluations') }}</b-alert>
                <img class="no-evaluations-placeholder mt-2" src="@/assets/images/evaluations.svg" />
            </div>
            <b-pagination
                v-if="pagination.total > 10"
                size="sm"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total-rows="pagination.total"
            />
            <router-view @spontaneous-evaluation-sented="onSentSpontaneousEvaluation" />
        </div>
    </b-card>
</template>
<script>
import { getSearchString } from '@/lib/api'
import { NavBar, Filters, Evaluation } from './components'
import { getEvaluationsList, getUserEvaluationsInfo, getQuestionnairesAvailableToEvaluate } from '@/views/values/api'
import { IconEvaluation } from '@/views/icons'

export default {
    name: 'Evaluations',
    components: {
        NavBar,
        Filters,
        Evaluation,
        IconEvaluation,
    },
    data() {
        return {
            selectedStatus: 'pending',
            evaluations: [],
            spontaneousQuestionnaires: [],
            evaluationAmounts: {
                editing: null,
                pending: null,
            },
            pagination: {
                total: null,
                perPage: 10,
                from: null,
                to: null,
                currentPage: 1,
            },
            filters: {
                networks: [],
                evaluateds: [],
                questionnaires: [],
            },
        }
    },
    mounted() {
        this.getEvaluationsInfo()
        this.getQuestionnairesAvailableToEvaluate()
    },
    methods: {
        onSentSpontaneousEvaluation() {
            if (this.selectedStatus == 'sent') {
                this.getEvaluations()
            }
        },
        onClickNavBarItem(evaluationStatus) {
            if (this.selectedStatus !== evaluationStatus) {
                this.selectedStatus = evaluationStatus
                this.pagination.currentPage = 1
                this.getEvaluations()
            }
        },
        onAcceptEvaluation(evaluationId) {
            this.getEvaluationsInfo()
            this.filterEvaluations(evaluationId)
        },
        onDeclineEvaluation(evaluationId) {
            this.getEvaluationsInfo()
            this.filterEvaluations(evaluationId)
        },
        onSentEvaluation(evaluationId) {
            this.getEvaluationsInfo()
            if (this.selectedStatus === 'pending') {
                this.filterEvaluations(evaluationId)
            }
        },
        filterEvaluations(evaluationId) {
            this.evaluations = this.evaluations.filter((e) => e.id !== evaluationId)
        },
        getEvaluations() {
            const loader = this.$loading.show({
                container: this.$refs.evaluations,
            })

            getEvaluationsList(this.filtersParams)
                .then((resp) => {
                    const { data, to, from, total, per_page, current_page } = resp

                    this.pagination = {
                        to,
                        from,
                        total,
                        perPage: per_page,
                        currentPage: current_page,
                    }

                    this.evaluations = data
                })
                .finally(() => {
                    loader.hide()
                })
        },
        getEvaluationsInfo() {
            getUserEvaluationsInfo(this.currentUser.id, {
                status: ['pending', 'editing'],
            }).then((amounts) => {
                this.evaluationAmounts = Object.keys(amounts).reduce((object, status) => {
                    return {
                        ...object,
                        [status]: parseInt(amounts[status]),
                    }
                }, {})
            })
        },
        getQuestionnairesAvailableToEvaluate() {
            getQuestionnairesAvailableToEvaluate(this.currentUser.id).then((questionnaires) => {
                this.spontaneousQuestionnaires = questionnaires
            })
        },
        getSpontaneousEvaluation() {
            this.$router.push('/v2/values/evaluations/spontaneous-evaluation')
        },
    },
    computed: {
        currentUser() {
            return this.$store.state.currentUser.user
        },
        showSpontaneousEvaluationButton() {
            return this.spontaneousQuestionnaires.length > 0
        },
        filtersParams() {
            return {
                and: 'yes',
                sortedBy: 'desc',
                orderBy: 'is_editing;sent_at',
                per_page: this.pagination.perPage,
                page: this.pagination.currentPage,
                search: getSearchString({
                    status: this.selectedStatus,
                    type: this.filters.networks,
                    valuer_id: this.currentUser.id,
                    evaluated_id: this.filters.evaluateds,
                    questionnaire_id: this.filters.questionnaires,
                }),
                with: 'questionnaire;evaluated',
                filter: 'questionnaire_id;id;evaluated_id;type;is_editing;status;evaluated.id;evaluated.name;evaluated.picture',
            }
        },
    },
    watch: {
        filters() {
            this.getEvaluations()
        },
        'pagination.currentPage': function (newValue, oldValue) {
            if (newValue != oldValue) {
                this.getEvaluations()
            }
        },
    },
}
</script>
<style scoped>
.no-evaluations-placeholder {
    max-width: 600px;
    max-height: 800px;
}
.page-title {
    color: #009ada;
    font-size: 1.2em;
}
</style>
